import * as Animations from './helpers/Animations'
import Utils from './helpers/Utils'
import Scroll from './components/Scroll'
import SwiperSlider from './components/SwiperSlider'
import Header from './components/Header'
import GSAP from './components/GSAP'

/**
 * Функція для ініціалізації всіх компонентів
 */
const AGDSApp = () => {

	// Start Loader
	window.addEventListener('load', () => {
		document.body.classList.add('_show')
	})

	// Options
	const options = {
		windowWidth: window.innerWidth || document.documentElement.clientWidth,
		overlay: document.getElementById('overlay'),
		preloader: document.getElementById('preloader'),
		header: document.getElementById('header'),
		swiperEls: document.querySelectorAll('.swiper'),
	}

	// Utils
	const utils = document.body ? new Utils() : null

	// GSAP
	const gsapIns = document.body
		? new GSAP()
		: null

	// Scroll
	const scroll = document.body
		? new Scroll({
			windowWidth: options.windowWidth,
			header: options.header,
		})
		: null

	// Swiper
	const swiper = options.swiperEls.length
		? new SwiperSlider({
			windowWidth: options.windowWidth,
			swiperEls: options.swiperEls,
		})
		: null

	// Header
	const header = options.header
		? new Header({
			windowWidth: options.windowWidth,
			overlay: options.overlay,
			animations: Animations,
			header: options.header,
		})
		: null

	// Ініціалізація
	utils?.init()
	scroll?.init()
	swiper?.init()
	gsapIns?.init()
	header?.init()
}

// Запуск програми після повного завантаження DOM
document.addEventListener('DOMContentLoaded', AGDSApp)